import { render, staticRenderFns } from "./AssignCar.vue?vue&type=template&id=16590ad4&scoped=true&"
import script from "./AssignCar.vue?vue&type=script&lang=js&"
export * from "./AssignCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16590ad4",
  null
  
)

export default component.exports